export default __webpack_public_path__ + "static/douglas-04f28fd3ee27c8bb5b30d24804037129.png";